import React from 'react'
import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Stack, Typography } from '@mui/material'
import { useDeleteChargingCard } from '../../api/use-delete-charging-card'
import { getChargingCardLabel } from '../../utils/get-charging-card-label'

export interface DeleteChargingCardDialogProps {
  ocpiTokenId: string
  installationId: string
  cardName: string | null
  open: boolean
  onClose: () => void
  place: number
  rfid: string
}

/**
 * Dialog component for delete charging cards which is open on click delete charging option in 3 dot menu
 * @param ocpiTokenId - unique identifier for single charging card
 * @param installationId - unique identifier for installation
 * @param cardName - charging card name as string or undefined
 * @param rfid - charging card rfid
 */
export const DeleteChargingCardDialog: React.FC<DeleteChargingCardDialogProps> = ({
  ocpiTokenId,
  installationId,
  open,
  onClose,
  place,
  cardName,
  rfid,
}) => {
  const { t } = useCustomTranslation()

  const { isLoading, deleteChargingCard } = useDeleteChargingCard(onClose, installationId)

  const handleDeleteChargingCard = async (): Promise<void> => {
    deleteChargingCard({ installationId, ocpiTokenId })
  }

  const chargingCardLabel = getChargingCardLabel({ rfid, cardName, t })

  return (
    <Dialog
      maxWidth={'sm'}
      title={t('emobility.chargingCards.delete-charging-card-title', { cardLabel: chargingCardLabel })}
      onClose={onClose}
      place={place}
      actions={{
        primary: {
          disabled: isLoading,
          isLoading: isLoading,
          name: t('common.delete'),
          onClick: handleDeleteChargingCard,
        },
        secondary: {
          name: t('common.cancel'),
        },
      }}
    >
      <Stack pt={3}>
        <Typography>{t('emobility.chargingCards.delete-charging-card-content')}</Typography>
      </Stack>
    </Dialog>
  )
}
